import React from 'react';
import styled from 'styled-components';
import '@mantine/core/styles/Menu.css';

import Menu from '../../Menu/Menu';
import { IconButton } from '../../Button/IconButton';
import { HudIcon } from '../../Icons/HudIcons';
import { themeColor } from '../../theme/colors';

interface HeadsUpIssueMenuProps {
  isMuted: boolean;
  isDetectionExcluded: boolean;
  isEditableRule: boolean;
  toggleMute: () => void;
  toggleMonitoring: () => void;
  editRule?: () => void;
  filterType?: 'endpoint';
}

export default function HeadsUpIssueMenu({
  isMuted,
  isDetectionExcluded,
  isEditableRule,
  toggleMute,
  toggleMonitoring,
  editRule,
  filterType,
  ...rest
}: HeadsUpIssueMenuProps) {
  const muteIcon = isMuted ? 'other.bell' : 'other.bellDisabled';
  const muteText = isMuted
    ? 'Enable Slack alerts for this endpoint'
    : 'Mute Slack alerts for this endpoint';

  const notMonitoredIcon = isDetectionExcluded ? 'other.ekg' : 'other.ekgDisabled';

  const notMonitoredText = isDetectionExcluded
    ? 'Start monitoring this endpoint'
    : 'Stop monitoring this endpoint';

  return (
    <Menu.Menu>
      <Menu.Target>
        <Container>
          <ActionButton icon="menu.horizontalDots" variant="text" />
        </Container>
      </Menu.Target>
      <SpacedMenuDropdown {...rest}>
        {!filterType && (
          <Menu.Item
            disabled={isDetectionExcluded}
            leftSection={<BorderedIcon size="30px" icon={muteIcon} />}
            onClick={toggleMute}
          >
            {muteText}
          </Menu.Item>
        )}
        {!filterType && (
          <Menu.Item
            leftSection={<BorderedIcon size="30px" icon={notMonitoredIcon} />}
            onClick={toggleMonitoring}
          >
            {notMonitoredText}
          </Menu.Item>
        )}

        {editRule && (
          <Menu.Item
            disabled={!isEditableRule}
            leftSection={<BorderedIcon size="30px" icon="other.filters" />}
            onClick={editRule}
          >
            Edit Rule
          </Menu.Item>
        )}
      </SpacedMenuDropdown>
    </Menu.Menu>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BorderedIcon = styled(HudIcon)`
  padding: 5px;
  border-radius: 7px;

  color: ${themeColor('textSecondary')};
  background: ${themeColor('strokeLight')};
`;

export const ActionButton = styled(IconButton)`
  padding: 2px;
`;

const SpacedMenuDropdown = styled(Menu.Dropdown)`
  padding: 12px 12px;

  /* Space children  (but not last) */
  & > .mantine-Menu-item {
    height: 39px;
  }
  & > .mantine-Menu-item:not(:last-child) {
    margin-bottom: 8px;
  }
`;
